import React, { FunctionComponent, MouseEvent, useState } from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import i18next from 'i18next';

import { COLORS } from 'helpers/enums/colors';

import { INavbarProps } from './types';
import {
  NavbarContainer,
  NavbarContent,
  NavbarMenuButton,
  NavbarAccountButton,
  NavbarProfileAvatar,
  NavbarMenu,
  NavbarMenuItem,
  NavbarMenuItemLabel,
  NavbarNavlinkContainer,
  NavbarNavlinkButton,
  NavbarLogoutButton,
} from './styles';
import './i18n';

const Navbar: FunctionComponent<INavbarProps> = (props: INavbarProps) => {
  const { initials, isMobile, isPublic, items, onLogoutPublicClick, onOpenMenu, title } = props;
  const [menuElement, setMenuElement] = useState<null | HTMLElement>(null);
  const EndIcon = !menuElement ? KeyboardArrowDown : KeyboardArrowUp;

  const onCloseAccountMenu = () => setMenuElement(null);

  const renderPublicButtons = () => (
    <>
      <NavbarNavlinkButton
        activeClassName="active"
        onClick={onCloseAccountMenu}
        to="/public/procedures/forms"
      >
        {i18next.t<string>('NAVBAR:PROCEDURES')}
      </NavbarNavlinkButton>
      <NavbarNavlinkButton
        activeClassName="active"
        onClick={onCloseAccountMenu}
        to="/public/procedures/list"
      >
        {i18next.t<string>('NAVBAR:MY_PROCEDURES')}
      </NavbarNavlinkButton>
      <NavbarNavlinkButton
        activeClassName="active"
        onClick={onCloseAccountMenu}
        to="/public/procedures/contact"
      >
        {i18next.t<string>('NAVBAR:CONTACT')}
      </NavbarNavlinkButton>
      <NavbarLogoutButton onClick={onLogoutPublicClick}>
        {i18next.t<string>('NAVBAR:LOG_OUT')}
      </NavbarLogoutButton>
    </>
  );

  return (
    <NavbarContainer auth data-testid="navbar">
      <NavbarContent auth isPublic={isPublic}>
        {!isPublic && <NavbarMenuButton data-testid="navbar-menu-button" onClick={onOpenMenu} />}
        {title}
        {isPublic &&
          (!isMobile ? (
            <NavbarNavlinkContainer>{renderPublicButtons()}</NavbarNavlinkContainer>
          ) : (
            <>
              <NavbarAccountButton
                aria-haspopup="true"
                data-testid="navbar-account-button"
                endIcon={<EndIcon color="inherit" />}
                isPublic
                onClick={(event: MouseEvent<HTMLButtonElement>) =>
                  setMenuElement(event.currentTarget)
                }
              >
                Menu
              </NavbarAccountButton>
              <NavbarMenu
                anchorEl={menuElement}
                isPublic
                onClose={onCloseAccountMenu}
                open={!!menuElement}
              >
                {renderPublicButtons()}
              </NavbarMenu>
            </>
          ))}
        {!isPublic && (
          <>
            <NavbarAccountButton
              aria-haspopup="true"
              data-testid="navbar-account-button"
              endIcon={<EndIcon color="action" />}
              onClick={(event: MouseEvent<HTMLButtonElement>) =>
                setMenuElement(event.currentTarget)
              }
            >
              <NavbarProfileAvatar alt={initials}>{initials}</NavbarProfileAvatar>
            </NavbarAccountButton>
            <NavbarMenu anchorEl={menuElement} onClose={onCloseAccountMenu} open={!!menuElement}>
              {items.map(({ Icon, key, label, onClick }) => (
                <NavbarMenuItem
                  data-testid={`navbar-menu-item-${key}`}
                  key={key}
                  onClick={() => {
                    onClick();
                    onCloseAccountMenu();
                  }}
                >
                  {Icon && <Icon fontSize="small" htmlColor={COLORS.grayScorpion} />}
                  <NavbarMenuItemLabel>{label}</NavbarMenuItemLabel>
                </NavbarMenuItem>
              ))}
            </NavbarMenu>
          </>
        )}
      </NavbarContent>
    </NavbarContainer>
  );
};

export default Navbar;
